// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  font-family: Lato,sans-serif;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
a.nav-link,a.nav-link:active{
  color:black;
}

a.nav-link:hover,a.nav-link,a.nav-link:active{
  color:black;
}

.nav-link {
  color:#000;
  padding: 10px 15px;
  display: block;
  text-decoration: none;
  font-family: 'Lato', sans-serif;
  transition: background-color 0.3s ease;
}

.nav-link:hover {
  color: #000;
}

.nav-link.active {
  background-color:#efefef; /* or your preferred color */
  border-radius: 5px;
}

.card-title{
  font-size: 16px;
  font-weight: bold;
}

.card-text{
  font-size: 14px;

}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB,EAAE,4BAA4B;EACtD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;;AAEjB","sourcesContent":["*{\n  font-family: Lato,sans-serif;\n}\n\nbody {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\na.nav-link,a.nav-link:active{\n  color:black;\n}\n\na.nav-link:hover,a.nav-link,a.nav-link:active{\n  color:black;\n}\n\n.nav-link {\n  color:#000;\n  padding: 10px 15px;\n  display: block;\n  text-decoration: none;\n  font-family: 'Lato', sans-serif;\n  transition: background-color 0.3s ease;\n}\n\n.nav-link:hover {\n  color: #000;\n}\n\n.nav-link.active {\n  background-color:#efefef; /* or your preferred color */\n  border-radius: 5px;\n}\n\n.card-title{\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.card-text{\n  font-size: 14px;\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
